<template>
    <div id="app" class="back">
        <v-app id="inspire">
            <v-app-bar clipped-left app flat dark color="transparent">
                <img class="logo" height="36" src="https://icon.irmastore.id/logoirmaputih.png"/>
                <v-spacer/>
                <v-toolbar-items>
                    <v-btn text>Fitur</v-btn>
                    <v-btn @click="login" text>Login</v-btn>
                    <v-btn @click="register" text>Register</v-btn>
                </v-toolbar-items>
            </v-app-bar>
            <v-content>
                <section id="hero">
                    <v-row no-gutters>
                        <v-img class="v-image__image--cover" :min-height="'calc(100vh - ' + $vuetify.application.top + 'px)'">
                            <v-theme-provider dark>
                                <v-container fill-height>
                                    <v-row align="center" class="white--text mx-auto" justify="center">
                                        <v-col class="white--text text-center" cols="12" tag="h1">
                                            <span :class="[$vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2']" class="font-weight-light">TUMBUH BERKEMBANG BERSAMA KAMI</span>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-theme-provider>
                        </v-img>
                    </v-row>
                </section>

                <section id="features" class="grey lighten-3">
                    <div class="py-12"></div>

                    <v-container class="text-center">
                        <h2 class="display-2 font-weight-bold mb-3">FITUR IRMA</h2>

                        <v-responsive
                                class="mx-auto mb-12"
                                width="56"
                        >
                            <v-divider class="mb-1"></v-divider>

                            <v-divider></v-divider>
                        </v-responsive>

                        <v-row>
                            <v-col
                                    v-for="({ icon, title, text }, i) in features"
                                    :key="i"
                                    cols="12"
                                    md="4"
                            >
                                <v-card
                                        class="py-12 px-4"
                                        color="grey lighten-5"
                                        flat
                                >
                                    <v-theme-provider dark>
                                        <div>
                                            <v-avatar
                                                    color="primary"
                                                    size="88"
                                            >
                                                <v-icon
                                                        large
                                                        v-text="icon"
                                                ></v-icon>
                                            </v-avatar>
                                        </div>
                                    </v-theme-provider>

                                    <v-card-title
                                            class="justify-center font-weight-black text-uppercase"
                                            v-text="title"
                                    ></v-card-title>

                                    <v-card-text
                                            class="subtitle-1"
                                            v-text="text"
                                    >
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-container>

                    <div class="py-12"></div>
                </section>

                <section id="stats">
                    <v-parallax :height="$vuetify.breakpoint.smAndDown ? 700 : 500" src="https://images.unsplash.com/photo-1510915228340-29c85a43dcfe?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80">
                        <v-container fill-height>
                            <v-row class="mx-auto">
                                <v-col v-for="[value, title] of stats" :key="title" cols="12" md="3">
                                    <div class="text-center">
                                        <div class="display-3 font-weight-black mb-4" v-text="value"></div>
                                        <div class="title font-weight-regular text-uppercase" v-text="title"></div>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-parallax>
                </section>

                <section id="blog" class="white">
                    <div class="py-12"></div>
                    <v-container>
                        <h2 class="display-2 font-weight-bold mb-3 text-uppercase text-center">Blog</h2>
                        <v-responsive class="mx-auto mb-12" width="56">
                            <v-divider class="mb-1"></v-divider>
                            <v-divider></v-divider>
                        </v-responsive>
                        <v-row>
                            <v-col
                                    v-for="({ src, text, title }, i) in articles"
                                    :key="i"
                                    cols="12"
                                    md="4">
                                <v-img :src="src" class="mb-4" height="275" max-width="100%"></v-img>

                                <h3 class="font-weight-black mb-4 text-uppercase" v-text="title"></h3>

                                <div class="title font-weight-light mb-5" v-text="text"></div>

                                <v-btn class="ml-n4 font-weight-black" text>Continue Reading</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                    <div class="py-12"></div>
                </section>
            </v-content>

            <v-footer class="justify-center" color="primary" height="100">
                <div class="title font-weight-light white--text text--lighten-1 text-center">
                    &copy; {{ (new Date()).getFullYear() }} — IRMA
                </div>
            </v-footer>
        </v-app>
    </div>
</template>

<script>
export default {
    components: {
    },
    name: "Landing",
    data:()=>({
        articles: [
            {
                src: 'https://images.unsplash.com/photo-1423784346385-c1d4dac9893a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80',
                title: 'Mobile first & Responsive',
                text: 'Phasellus lorem enim, luctus ut velit eget, convallis egestas eros. Sed ornare ligula eget tortor tempor, quis porta tellus dictum.',
            },
            {
                src: 'https://images.unsplash.com/photo-1475938476802-32a7e851dad1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80',
                title: 'Think outside the box',
                text: 'Nam ut leo ipsum. Maecenas pretium aliquam feugiat. Aenean vel tempor est, vitae tincidunt risus. Sed sodales vestibulum nibh.',
            },
            {
                src: 'https://images.unsplash.com/photo-1416339442236-8ceb164046f8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1892&q=80',
                title: 'Small changes, big difference',
                text: 'Vestibulum in dictum velit, in rhoncus nibh. Maecenas neque libero, interdum a dignissim in, aliquet vitae lectus. Phasellus lorem enim, luctus ut velit eget.',
            },
        ],
        features: [
            {
                icon: 'mdi-account-group-outline',
                title: 'Isi Ulang & Produk Digital',
                text: 'Pulsa, paket data, paket bicara & SMS semua operator, voucher game, voucher diskon, token listrik PLN dan lainnya',
            },
            {
                icon: 'mdi-account-group-outline',
                title: 'Bayar Tagihan',
                text: 'Tagihan Listrik, langganan PDAM, Tagihan berbagai Multi Finance, PGN dan lainnya',
            },
            {
                icon: 'mdi-update',
                title: 'Jasa Kirim Uang',
                text: 'Menghadirkan layanan kirim uang ke akun bank, kirim kas melalui kode pencairan dan jasa pencairan kas',
            },
            {
                icon: 'mdi-shield-outline',
                title: 'Jual/Beli Barang Fisik',
                text: 'Penuhi kebutuan warung/toko anda, dan menambah penghasilan menjadi penjual terpercaya',
            },
            {
                icon: 'mdi-shield-outline',
                title: 'Akses Kredit Modal Kerja',
                text: 'Akses kredit modal kerja untuk pembelian saldo multi secara cepat dan ringan',
            },
            {
                icon: 'mdi-shield-outline',
                title: 'Isi Ulang Saldo Multi Cepat',
                text: 'Isi ulang saldo dengan beragam channel,VA,Emoney,Alfamart,Indomaret',
            },
        ],
        stats: [
            ['24k', 'Github Stars'],
            ['330+', 'Releases'],
            ['1m', 'Downloads/mo'],
            ['5m', 'Total Downloads'],
        ],
    }),
    methods: {
        login(){
            this.$router.push("/login")
        },
        register(){
            this.$router.push("/register")
        }
    }
}
</script>

<style scoped>
    .back {
        background-image: linear-gradient(to right, rgba(5, 11, 31, 0.8), rgba(5, 11, 31, 0.8)), url("https://aviana.co.id/public/img/3.png");
        background-size: contain;
    }
    #inspire {
        background: none !important;
    }
    .logo {
        background-position: left;
    }
</style>
